import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { GraduationCap, ArrowRight, BookOpen } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import SEO from '../components/SEO';
import LoadingScreen from '../components/LoadingScreen'; // <--- IMPORT STANDARD

const Departments = () => {
  const [depts, setDepts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const { data, error } = await supabase
        .from('departments')
        .select('*, courses(count)');
      
      if (error) throw error;
      setDepts(data || []);
    } catch (error) {
      console.error("Errore fetch dipartimenti:", error);
    } finally {
      setLoading(false);
    }
  };

  // --- LOADING SCREEN STANDARD ---
  if (loading) return <LoadingScreen />;

  return (
    <div className="relative min-h-screen bg-slate-50 pt-24 pb-20 px-6 font-sans text-slate-800">
      <SEO title="Dipartimenti" description="Scegli il tuo dipartimento Unitus." url="/dipartimenti" />
      
      {/* SFONDO DECORATIVO (Tema Indigo) */}
      <div className="absolute top-0 left-[-10%] w-[500px] h-[500px] bg-indigo-100/60 rounded-full blur-[100px] mix-blend-multiply pointer-events-none"></div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <PageHeader 
            title="Dipartimenti" 
            subtitle="Esplora i corsi di laurea e le risorse." 
            breadcrumbs={[{label: 'Dipartimenti'}]} 
        />

        {depts.length > 0 ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
              {depts.map((dept) => (
                <Link key={dept.id} to={`/dept/${dept.id}`} className="group bg-white rounded-[2.5rem] p-8 border border-slate-100 hover:border-indigo-200 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 relative overflow-hidden flex flex-col">
                  
                  {/* Icona Sfondo Decorativa */}
                  <div className="absolute top-[-20px] right-[-20px] text-slate-50 opacity-50 group-hover:opacity-10 transition-opacity duration-500 transform rotate-12 group-hover:rotate-0">
                      <BookOpen size={180} />
                  </div>

                  {/* Icona Dipartimento */}
                  <div className={`w-16 h-16 rounded-2xl ${dept.color ? dept.color.replace('bg-', 'text-').replace('500', '600') : 'text-indigo-600'} bg-slate-50 flex items-center justify-center mb-6 shadow-sm border border-slate-100 group-hover:scale-110 transition-transform duration-300`}>
                    <GraduationCap size={32} />
                  </div>

                  <h3 className={`text-2xl font-black mb-3 leading-tight group-hover:opacity-80 transition-colors ${dept.color ? dept.color.replace('bg-', 'text-').replace('500', '900') : 'text-slate-900'}`}>
                    {dept.acronym}
                  </h3>
                  <p className="text-sm text-slate-500 font-medium mb-8 line-clamp-2 leading-relaxed h-10">{dept.name}</p>

                  <div className="flex items-center justify-between mt-auto border-t border-slate-50 pt-6">
                    <span className="text-xs font-bold bg-slate-100 text-slate-500 px-3 py-1.5 rounded-lg uppercase tracking-wide">
                        {dept.courses[0]?.count || 0} Corsi
                    </span>
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 ${dept.color ? `bg-slate-50 text-slate-400 group-hover:text-white group-hover:${dept.color}` : 'bg-slate-50 text-slate-400 group-hover:bg-indigo-600 group-hover:text-white'}`}>
                      <ArrowRight size={20} />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
        ) : (
            <div className="text-center py-24">
                <p className="text-slate-400 font-bold">Nessun dipartimento trovato.</p>
            </div>
        )}
      </div>
    </div>
  );
};

export default Departments;